import { createAsyncThunk } from '@reduxjs/toolkit';
import templateApi from '~/apis/template';
import { GET_TEMPLATE, CREATE_TEMPLATE, SHOW_TEMPLATE, UPDATE_TEMPLATE } from '~/utils/constants/actionType';
import {
  IEditTemplate,
  IParamsGetTemplate,
  IResponseGetTemplate,
  IResponseGetTemplateDetail,
} from '~/utils/interface/template';

export const handleGetTemplates = createAsyncThunk<IResponseGetTemplate, IParamsGetTemplate>(
  GET_TEMPLATE,
  async (params: IParamsGetTemplate = {}, { rejectWithValue }) => {
    try {
      const res = await templateApi.getTemplates(params);

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleCreateTemplate = createAsyncThunk<IResponseGetTemplateDetail, IEditTemplate>(
  CREATE_TEMPLATE,
  async (data: IEditTemplate, { rejectWithValue }) => {
    try {
      const res = await templateApi.createTemplate(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetTemplate = createAsyncThunk<IResponseGetTemplateDetail, { id: string; type: string }>(
  SHOW_TEMPLATE,
  async ({ id, type }, { rejectWithValue }) => {
    try {
      const res = await templateApi.getTemplate(id, type);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleUpdateTemplate = createAsyncThunk<
  null,
  { id: string | undefined; type: string | undefined; params: IEditTemplate }
>(UPDATE_TEMPLATE, async ({ id, type, params }, { rejectWithValue }) => {
  try {
    const res = await templateApi.updateTemplate(id, type, params);
    return res.data.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
